import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Layout, Modal, Row, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import Header from '../../common/compornents/layout/header/Header';
import HeaderRow2 from '../../common/compornents/layout/header/HeaderRow2';
import ProductSearchTable from '../../common/compornents/layout/table/ProductSearchTable';
import { notificationError, notificationInfo } from '../../common/compornents/notification';
import { Const } from '../../common/constants/Constants';
import { Message } from '../../common/constants/Message';
import { generateMessage } from '../../common/util/MessageUtil';
import SeihinServ from '../../services/SeihinServ';

const { Footer } = Layout;

interface IProps {
  tok_cd: string;
  tok_cd2: string;
  cd: string;
  setCd: (cd: string) => void;
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const ProductSearch: React.FC<IProps> = (props: IProps) => {
  //sessionStorageから取得
  var compnyNm = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_NAME) ?? '';
  var accNm = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TANTO_NAME) ?? '';

  const [form] = Form.useForm();
  const [seihinList, setSeihinList] = useState<any[]>([]);
  const [rIdx, changeRowIndex] = useState(-1);

  //行選択
  useEffect(() => {
    if (rIdx >= 0) {
      props.setCd(seihinList[rIdx].cd);
      dataClear();
      changeRowIndex(-1);
      props.setVisible(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rIdx]);

  //検索ボタン押下
  function dataSearch() {
    let data = form.getFieldsValue();

    // 前画面からの条件
    var cd1 = props.tok_cd;
    var cd2 = props.tok_cd2;
    // 画面入力条件
    var nm1 = data.searchNm1 || '';
    var nm2 = data.searchNm2 || '';
    var nm3 = data.searchNm3 || '';

    // APIに渡すパラメーターを設定
    var params = {
      nm1: nm1,
      nm2: nm2,
      nm3: nm3,
      cd1: cd1,
      cd2: cd2,
    };

    // APIを呼び出しDBから値を取得
    SeihinServ.getSeihinData(params)
      .then((json) => {
        if (json.data.length >= 1000) {
          notificationInfo('製品検索', generateMessage(Message.INFO_MASSAGE.INF010));
        }
        setSeihinList(() => json.data);
      })
      .catch((error) => {
        notificationError('製品検索', generateMessage(Message.ERROR_MASSAGE.ERR999, '製品検索'));
      });
  }

  //クリアボタン押下
  function dataClear() {
    form.resetFields();
    setSeihinList(() => []);
  }

  //閉じるボタン押下
  function winClose() {
    dataClear();
    props.setVisible(false);
  }

  return (
    <Modal closable={false} footer={null} visible={props.visible} width={1000} centered>
      <Header screenName={'製品検索'} />
      <Form
        form={form}
        layout="horizontal"
        autoComplete="off"
        style={{ backgroundColor: '#e6f7ff' }}
      >
        {/* ヘッダ情報（カンパニー、お客先様） */}
        <HeaderRow2 compnyNm={compnyNm} accNm={accNm} />
        {/* 製品名検索文字と検索ボタンとクリアボタン*/}
        <Row style={{ paddingTop: '1vh' }}>
          <Col offset={1} lg={3} md={4} sm={5} xs={4}>
            <Form.Item label="製品名検索文字"></Form.Item>
          </Col>
          <Col lg={4} md={3} xs={5}>
            <Form.Item name={'searchNm1'}>
              <Input maxLength={8} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item>&</Form.Item>
          </Col>
          <Col lg={4} md={3} xs={5}>
            <Form.Item name={'searchNm2'}>
              <Input maxLength={8} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item>&</Form.Item>
          </Col>
          <Col lg={4} md={3} xs={5}>
            <Form.Item name={'searchNm3'}>
              <Input maxLength={8} />
            </Form.Item>
          </Col>
          <Col md={{ offset: 1 }} sm={{ offset: 15 }} xs={{ offset: 13 }}>
            <Space size={'large'}>
              <Button type="primary" onClick={dataSearch}>
                <SearchOutlined />
                検索
              </Button>
              <Button type="primary" onClick={dataClear}>
                クリア
              </Button>
            </Space>
          </Col>
        </Row>

        {/* テーブル */}
        <Row style={{ paddingTop: '2vh' }}>
          <Col offset={1} xs={22}>
            <ProductSearchTable
              dataSeihin={seihinList}
              rowIndex={rIdx}
              changeRowIndex={changeRowIndex}
            />
          </Col>
        </Row>
      </Form>

      {/* 閉じるボタン */}
      <Footer
        style={{
          backgroundColor: '#e6f7ff',
          height: '70px',
        }}
      >
        <Row justify="end">
          <Col>
            <Button type="primary" onClick={winClose}>
              閉じる
            </Button>
          </Col>
        </Row>
      </Footer>
    </Modal>
  );
};

export default ProductSearch;
